<template>
    <div class="container">
        <div class="list">
            <div
                class="item"
                v-for="(item, index) in list"
                :key="index"
                @click="toDetails(item)"
            >
                <van-tag mark size="large" class="date">
                    {{ _.split(item.endTime, " ")[0] }}
                </van-tag>
                <div class="header">
                    <span class="title">病历编号：{{ item.id }}</span>
                </div>
                <van-divider />
                <div class="line">
                    <van-row class="row">
                        <van-col span="12" class="title">
                            患者姓名：{{ item.patientName }}
                        </van-col>
                        <van-col span="12" class="title">
                            性别：{{ item.gender==1?'男':'女' }}
                        </van-col>
                    </van-row>
                    <van-row class="row">
                        <van-col span="24" class="title">
                            病情描述： {{ item.diseaseDesc }}
                        </van-col>
                    </van-row>
                </div>
                <van-divider />
                <div class="footer">
                    <span class="more">病历详情 ></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import manageApi from '@/api/manageApi';

export default {
    data() {
        return {
            list: []
        };
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            this.list = [];
            let organCode = this.organInfo.organCode;
            manageApi.queryByMedicalRecord(this.idCard,organCode).then(res => {
                this.list = res.data;
                console.log(this.list)
            });
        },
        toDetails(item) {
            const { $router } = this;
            $router.push({
                path: '/manage/case_history',
                query: {
                    medicalRecordId: item.id
                }
            });
        }
    },
    props: {
        idCard: {
            type: String,
            required: false
        }
    },
    computed: {
        organInfo() {
            return this.$hdk.data(this.$setter.organInfo);
        }
    },
}
</script>


<style lang="less" scoped>
.container {
    .list {
        /deep/.van-divider {
            margin: 0.266667rem 0;
        }
        .item {
            margin: 0.266667rem;
            border-radius: 0.2rem;
            background-color: @white-color;
            padding: 0.266667rem;
            box-shadow: 0.08rem 0.08rem 0.106667rem rgba(26, 26, 26, 0.2);
            font-size: 0.32rem;

            .date {
                background-image: linear-gradient(
                    45deg,
                    @deputy-color,
                    @primary-color
                );
                margin-left: -0.533333rem;
            }

            .header {
                margin-top: 0.266667rem;
                padding: 0 0.266667rem;
                color: @grey-color;

                .title {
                    color: @black-color;
                }
            }

            .line {
                position: relative;
                .row {
                    position: relative;
                    padding: 0.133333rem 0.266667rem;
                    line-height: 0.4rem;
                    color: @grey-color;

                    .title {
                        color: @black-color;
                    }
                }
            }

            .footer {
                text-align: center;
                color: @primary-color;
            }
        }
    }
}
</style>